import * as type from "./types";

export function searchGodown(value, name, cid) {
  return {
    type: type.SEARCH_GODOWN,
    payload: value,
    name,
    cid
  };
}

export function storeGodownResult(list, name) {
  return {
    type: type.STORE_GODOWN_RESULT,
    payload: list,
    name
  };
}
